import React, { useState, useEffect } from 'react';
import './App.css';
import CountrySelection from './components/CountrySelection';
import WaitlistScreen from './components/WaitlistScreen';
import PhoneAuth from './components/PhoneAuth';
import OTPVerification from './components/OTPVerification';
import HomeScreen from './components/HomeScreen';

function App() {
  const [currentScreen, setCurrentScreen] = useState('country'); // 'country', 'phone', 'otp', 'home', 'waitlist'
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userId, setUserId] = useState(null);

  // Check if user is already logged in
  useEffect(() => {
    const savedUser = localStorage.getItem('homie_user');
    if (savedUser) {
      const user = JSON.parse(savedUser);
      setUserId(user.id);
      setSelectedCountry(user.country);
      setPhoneNumber(user.phone);
      setCurrentScreen('home');
    }
  }, []);

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    if (country.available) {
      setCurrentScreen('phone');
    } else {
      setCurrentScreen('waitlist');
    }
  };

  const handlePhoneSubmit = async (phone) => {
    setPhoneNumber(phone);
    // Show OTP screen (dummy verification)
    setCurrentScreen('otp');
  };

  const handleOTPVerify = async (otp) => {
    // Dummy OTP - accept any 6-digit code
    if (otp.length === 6 && /^\d+$/.test(otp)) {
      const user = {
        id: 'user_' + Date.now(),
        phone: phoneNumber,
        country: selectedCountry
      };
      localStorage.setItem('homie_user', JSON.stringify(user));
      setUserId(user.id);
      setCurrentScreen('home');
      return true;
    }
    return false;
  };

  const handleWaitlistSubmit = (email) => {
    // In production, save email to database
    alert(`Thanks for joining the waitlist for ${selectedCountry.name}!\n\nWe'll notify you at ${email} when we launch.`);
    setCurrentScreen('country');
    setSelectedCountry(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('homie_user');
    setCurrentScreen('country');
    setSelectedCountry(null);
    setPhoneNumber('');
    setUserId(null);
  };

  const handleBack = () => {
    if (currentScreen === 'phone' || currentScreen === 'waitlist') {
      setCurrentScreen('country');
      setSelectedCountry(null);
    } else if (currentScreen === 'otp') {
      setCurrentScreen('phone');
    }
  };

  return (
    <div className="app">
      {currentScreen === 'country' && (
        <CountrySelection onCountrySelect={handleCountrySelect} />
      )}
      {currentScreen === 'waitlist' && selectedCountry && (
        <WaitlistScreen 
          country={selectedCountry}
          onSubmit={handleWaitlistSubmit}
          onBack={handleBack}
        />
      )}
      {currentScreen === 'phone' && (
        <PhoneAuth 
          country={selectedCountry}
          onSubmit={handlePhoneSubmit}
          onBack={handleBack}
        />
      )}
      {currentScreen === 'otp' && (
        <OTPVerification 
          phoneNumber={phoneNumber}
          onVerify={handleOTPVerify}
          onBack={handleBack}
        />
      )}
      {currentScreen === 'home' && (
        <HomeScreen 
          userId={userId}
          country={selectedCountry}
          onLogout={handleLogout}
        />
      )}
    </div>
  );
}

export default App;
